import { ActionReducer } from '@ngrx/store/src/models';
import { createFeature, createReducer, on } from '@ngrx/store';
import { SCORED_CONVERSATIONS_ACTIONS, SCORED_CONVERSATIONS_API_ACTIONS } from './scored-conversations.actions';
import { IGroupedScoredConversation, ScoredConversationModel } from '../models/scored-conversations.model';

export const SCORED_CONVERSATIONS_STATE_KEY = 'scored-conversations';

export interface IScoredConversationsState {
  data: ScoredConversationModel[] | IGroupedScoredConversation[];
  loading: boolean;
  error: Error | null;
  totalCount: number;
  activeViewLabel: string | null;
}

export const conversationsState: IScoredConversationsState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  activeViewLabel: null,
};

const reducer: ActionReducer<IScoredConversationsState> = createReducer<IScoredConversationsState>(
  conversationsState,
  on(SCORED_CONVERSATIONS_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SCORED_CONVERSATIONS_API_ACTIONS.success, (state, { scorecardsConversations, totalCount }) => ({
    ...state,
    loading: false,
    data: scorecardsConversations,
    totalCount,
  })),
  on(SCORED_CONVERSATIONS_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    totalCount: 0,
    error,
  })),
  on(SCORED_CONVERSATIONS_ACTIONS.setActiveView, (state, { viewName }) => ({
    ...state,
    activeViewLabel: viewName,
  })),
);

export const SCORED_CONVERSATIONS_REDUCER = createFeature({
  name: SCORED_CONVERSATIONS_STATE_KEY,
  reducer,
});
